import { Image, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { EProjectType } from '../../../enum/project';
import LogoMacroDesign from '../../../images/logo_macro.jpg';
import { IProjectInfoForm } from '../../../pages/ProjectInfo/IProjectInfo';
import { styles } from '../PDFStyle';
import SVGLogo from './SVGLogo';

interface IPDFHeaderProps {
    projectInfo: IProjectInfoForm;
}

const PDFHeader = (props: IPDFHeaderProps) => {
    const { t, i18n } = useTranslation();
    const { projectInfo} = props;
    return (
        <View style={styles.header} fixed>
            <View style={styles.borderBottom}>
                <View style={styles.body}>
                    <View style={styles.headerColumn}>
                        <SVGLogo  />
                    </View>
                    <View style={styles.headerColumn}>
                        <View style={styles.rowCentered}>
                            <Text style={styles.headerBold}>{projectInfo.projectType + t("pdf_header_macro_design")}</Text>   
                            <Text> {t("pdf_header_technical_report")} </Text>             
                       </View>
                       <View style={styles.rowCentered}>
                            <Text style={styles.boldGreen}>{t('pdf_header_app_description')}</Text>        
                       </View>
                   </View>
                   <View style={styles.headerColumn}>
                        <View style={styles.rowCentered}>       
                            <Text style={styles.subtitle}>{t("pdf_header_site")}</Text>
                       </View>
                       <View style={styles.rowCentered}>
                            <Text style={styles.headerPage} render={({ pageNumber, totalPages }) => t("pdf_page") + `  ${pageNumber} / ${totalPages}`} />
                       </View>
                   </View>
                </View>
            </View>
        </View>
    );
};

export default PDFHeader;
